/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { memoize } from 'lodash';
import { reindexMapFromIds } from 'edrolo/reducers/utils';
import LoadingIndicator from 'edrolo/domains/app/components/LoadingIndicator';
import {
  actions as progressActions,
  selectors as progressSelectors,
} from 'edrolo/reducers/progress';

const makeSelectors = memoize(
  (classId, lessonId) => {
    // returns a function to lookup class progress by classId
    const getClassLessonProgress = createSelector(
      [progressSelectors.getAllClassLessonProgress],
      (allClassLessonProgress) =>
        allClassLessonProgress &&
        allClassLessonProgress.getIn([`${classId}`, `${lessonId}`])
    );

    const getClassStudentLessonProgressByProfile = createSelector(
      [getClassLessonProgress, progressSelectors.getAllStudentLessonProgress],
      (classLessonProgress, allStudentLessonProgress) => {
        const studentProgressIds =
          classLessonProgress && classLessonProgress.get('student_progress');
        return reindexMapFromIds(
          studentProgressIds,
          allStudentLessonProgress,
          'profile_id'
        );
      }
    );

    return {
      getClassLessonProgress,
      getClassStudentLessonProgressByProfile,
    };
  },
  (classId, lessonId) => `${classId}-${lessonId}`
);

const mapStateToProps = (state, ownProps) => {
  const classId = ownProps?.match?.params?.classId;
  const lessonId = ownProps?.match?.params?.lessonId;
  const selectors = makeSelectors(classId, lessonId);

  return {
    lessonId,
    classId,
    classLessonProgress: selectors.getClassLessonProgress(state, ownProps),
    classStudentLessonProgress:
      selectors.getClassStudentLessonProgressByProfile(state, ownProps),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadClassLessonProgress: () =>
    dispatch(
      progressActions.loadClassLessonProgress.signal(
        ownProps?.match?.params?.classId,
        ownProps?.match?.params?.lessonId
      )
    ),
});

export default function classLessonProgressLoader(WrappedComponent) {
  @connect(mapStateToProps, mapDispatchToProps)
  class ClassLessonProgressLoader extends Component {
    componentDidMount() {
      if (!this.props.lessonId || !this.props.classId) {
        return;
      }

      if (!this.props.classLessonProgress) {
        global.ifDev(
          `loading class lesson progress (class:${this.props.classId}, lesson:${this.props.lessonId})`
        );
        this.props.loadClassLessonProgress(
          this.props.classId,
          this.props.lessonId
        );
      }
    }

    render() {
      return !this.props.classLessonProgress ? (
        <LoadingIndicator loadingText={'Loading Student Progress'}>
          <WrappedComponent {...this.props} />
        </LoadingIndicator>
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  }

  return ClassLessonProgressLoader;
}
